export const GET_PROJECT_COMMENTS = 'GET_PROJECT_COMMENTS'
export const RESPONSE_STATUS = 'RESPONSE_STATUS'
export const GET_FETCH_DATA = 'GET_FETCH_DATA'
export const CLEAR_RESPONSE = 'CLEAR_RESPONSE'
